import { extractTextForIOS, extractTextForIOS_Onboarding } from '../Utils/StringFilesConfiguration';
import ExportFileManger from './ExportFileManger';
import { onboardingImagesNames } from '../../utils/DictionaryManagementUtils';

const ios_dir = 'ios/';
const ios_extension_2 = '@2x';
const ios_extension_3 = '@3x';

const snapshot_ios_select_kbd = 2;
const snapshot_ios_menu = 4;
const snapshot_ios_back_or_stickers = 5;
const snapshot_ios_phone_image = 8;

export default function IosFileManger(exportHandler, snapshotsOnboarding) {
  ExportFileManger.call(this, exportHandler, snapshotsOnboarding, false);
  this.skipResize = true;

  this.exportStrings = async (configurations) => {
    await this.exportHandler.exportXML(extractTextForIOS(configurations), `${this.getBaseDirectory()}Strings.plist`);
  };

  this.exportOnboardingString = async (configurations) => {
    await this.exportHandler.exportXML(extractTextForIOS_Onboarding(configurations), `${this.getBaseDirectory()}${this.getOnboardingDirectory()}Strings.plist`);
  };

  this.exportOnboardingIcons = async (onboarding) => {
    const exportImagesList = [
      { name: onboardingImagesNames.ic_onboarding_intro, file: onboarding.announcement.kbd_announcement_icon },
      { name: onboardingImagesNames.ic_activation_success, file: onboarding.instructions.kbd_success_icon },
      { name: onboardingImagesNames.ic_ios_come_back, file: onboarding.instructions.kbd_come_back_icon },
      {
        name: onboardingImagesNames.ic_onboarding_typing_experience,
        file: { fUri: await this.handleSnapshots(snapshot_ios_phone_image) },
      },
      {
        name: onboardingImagesNames.ic_onboarding_services,
        file: { fUri: await this.handleSnapshots(snapshot_ios_menu) },
      },
      {
        name: onboardingImagesNames.ic_ios_select_keyboard,
        file: { fUri: await this.handleSnapshots(snapshot_ios_select_kbd) },
      },
      {
        name: onboardingImagesNames.ic_onboarding_security,
        file: { fUri: await this.handleSnapshots(snapshot_ios_back_or_stickers) },
      },
      {
        name: onboardingImagesNames.ic_onboarding_media,
        file: { fUri: await this.handleSnapshots(snapshot_ios_back_or_stickers) },
      },
    ];
    await this.exportIcons(exportImagesList, true);
  };

  this.skipDeviceResizeImages = (exportImages) => exportImages
    .map(({ name, img }) => this.resizeImage(img, name, 1));

  this.deviceResizeImages = (exportImages) => {
    const exportImagesResize = [];
    exportImages.forEach(({ name, img }) => {
      exportImagesResize.push(this.resizeImage(img, `${name}`, 0.25));
      exportImagesResize.push(this.resizeImage(img, `${name}${ios_extension_2}`, 0.5));
      exportImagesResize.push(this.resizeImage(img, `${name}${ios_extension_3}`, 1));
    });
    return exportImagesResize;
  };

  this.getBaseDirectory = () => ios_dir;
}
